import React from "react"
import { Link } from "gatsby"

import Layout from "../../../components/layout"
import { FooterAlternate1 } from "../../../components/footer"
import SEO from "../../../components/seo"

const IndexPage = () => (
    <Layout>
      <SEO title="Sales uplift - 2 simple ways to create performance improvement." />

                     
<nav className="share-bar">
    <ul>
        <li className="linkedin">
            <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https%3A//salestribe.com/knowledge-centre/insights/sales-uplift-two-simple-ways-create-sales-performance-improvement/&amp;title=Sales%20uplift%20-%202%20simple%20ways%20to%20create%20performance%20improvement.&amp;summary=Sales%20uplift%20-%202%20simple%20ways%20to%20create%20performance%20improvement.&amp;source=https%3A//salestribe.com/knowledge-centre/insights/sales-uplift-two-simple-ways-create-sales-performance-improvement/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">LinkedIn</span>
                <span className="icon">
                    <svg width="23" height="23">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-linkedin-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="twitter">
            <a href="https://twitter.com/intent/tweet/?text=Sales%20uplift%20-%202%20simple%20ways%20to%20create%20performance%20improvement.&amp;url=https%3A//salestribe.com/knowledge-centre/insights/sales-uplift-two-simple-ways-create-sales-performance-improvement/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Twitter</span>
                <span className="icon">
                    <svg width="23" height="23">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-twitter-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="googleplus">
            <a href="https://plus.google.com/share?url=https%3A//salestribe.com/knowledge-centre/insights/sales-uplift-two-simple-ways-create-sales-performance-improvement/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Google+</span>
                <span className="icon">
                    <svg width="26" height="26">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-googleplus-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="facebook">
            <a href="https://facebook.com/sharer/sharer.php?u=https%3A//salestribe.com/knowledge-centre/insights/sales-uplift-two-simple-ways-create-sales-performance-improvement/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Facebook</span>
                <span className="icon">
                    <svg width="22" height="22">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-facebook-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="email">
            <Link to="knowledge-centre/insights/mailto:?subject=Sales%20uplift%20-%202%20simple%20ways%20to%20create%20performance%20improvement.&amp;body=https%3A//salestribe.com/knowledge-centre/insights/sales-uplift-two-simple-ways-create-sales-performance-improvement/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Email</span>
                <span className="icon">
                    <svg width="20" height="20">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-email-badge"></use>
                    </svg>
                </span>
            </Link>
        </li>
    </ul>
</nav>

<article className="article">

    

<header className="header header--article article__header" id="page-header">
    <div className="header__image" >
        <div className="header__bgimage" style={{backgroundImage: "url(../../../media/images/article-success-mind-climb.2e16d0ba.fill-1162x655.jpg)"}}></div>
        <div className="header__video">
            <div className="embed-responsive embed-responsive-16by9"></div>
        </div>
    </div>
    <div className="header__content">
        <div className="container">
            <div className="row">
                <div className="header__inner col-md-7 col-lg-offset-1">
                    <Link to="knowledge-centre/insights/" className="header__back back-link">
                        <span className="sr-only">Back to all articles</span>
                        <i className="icon"></i>
                    </Link>
                    <div className="header__title">
                        <h3>B2B Sales</h3>
                        <h1>Sales uplift - 2 simple ways to create performance improvement.</h1>
                    </div>
                    <ul className="post-meta-list">
                        <li>by Graham Hawkins</li>
                        <li>3 May 2016</li>
                        <li>3 min read</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</header>


<div className="container" id="article-content">
    <div className="row">
        <div className="article__body col-sm-12 col-md-8 col-lg-offset-1 col-lg-7 wysiwyg">
            
<h3>Some sales basics that many seem to forget!</h3>
<p>Sales leaders are always searching for levers that can provide an uplift in sales performance, and two of the best known and most effective means by which to refocus the sales teams is around Average Order Value (AOV), and Average Sales Cycle Time (ASCT). Strangely, sales leaders often forget these two important business fundamentals – mainly because of the incessant short term pressure on pipeline development and closing sales regardless of margin, cost of sale or profitability.....just <em>close! close! close!</em></p>
<div className="rich-text"><p>Of course, it always varies according to the individual, but each sales person can only manage a certain number of sales opportunities at any given point in time. Understanding the maximum production efficiency for each individual member of the sales team allows the sales leader to begin to conduct what I believe is vitally important business analysis into <strong>total sales capacity</strong>……which then plays a critical role in <em>coverage model</em> and <em>go-to-market</em> planning. If you agree with me on this then it follows that it is really only possible to increase total sales output by one of two means:</p><ol><li>Increase the AOV to produce greater revenue for the same number of transactions.</li><li>Compress the ASCT to facilitate more transactions within the same time period.<strong> </strong></li></ol><p><strong>Increasing AOV</strong> is sometimes as simple as creating some focus on each and every transaction. Whilst the terms <em>cross-sell</em> and <em>up-sell</em> are both drastically overused these days, the concepts remain valid in practically every selling context, and in every market globally. Buyers like to receive some sort of discounted value-add or additional extra for their purchase, and sales leaders are always delighted with every extra dollar of revenue that can be recognized per transaction. I always think of the 16 year old McDonald’s employee who is trained to always ask <em>“would you like some fries with that”.</em>Strangely, I know lots of professional sales people that earn many orders of magnitude more than the average McDonalds worker that simply forget to ask their customers the basic <em>up-sell</em> questions. Why? Some of this comes back to the tyranny of short-termism which nearly always translates to huge pressure for the sales person to URGENTLY close the sale......some sales people either forget to ask the <em>upsell</em> questions whilst others are so worried about the possibility of complicating/delaying the deal that they deliberately avoid going down that path with their customers. Either way – revenue is left on the table.</p><p><strong>Decreasing ASCT </strong>– those sales leaders that have their finger on the pulse will know intimately the steps involved in the typical sales cycle for each and every product (and service) that they push into their target markets. These savvy sales leaders will always be searching for ways in which to compress the time (and therefore reduce the cost) that it takes to bring each sales opportunity to a successful close. ASCT can simply be extrapolated out over the total number of sales resources available to provide a good indicator of the total possible revenue for a period (for a set number of resources) if the sales execution plan is fully optimized. </p></div>
<img alt="Sales Cycle Time" className="img-responsive" height="431" src="../../../media/images/AAEAAQAAAAAAAAf7AAAAJGM5NDY0ZmRlLTYzNDYtNDMwOC.width-647.png" width="647"/>

<div className="rich-text"><p>So, if ASCT can be reduced then a business can logically process more transactions within the same period meaning that each sales person can manage more sales, and book more revenue within a given sales period. From my own experience this is yet another simple but often overlooked lever that sales leaders should always use when searching for a performance uplift. Like AOV, if sales people are not constantly looking for ways to decrease ASCT, then naturally they won’t find them. Simple as that.</p><p>In sum, ASCT x AOV allows sales leaders to calculate total sales revenue <strong>capacity</strong>, and this should be the starting point for all sales planning, including providing an <em>evidence-based</em> guide for quota setting. Highlighting ASCT and or AOV as key sales measurements or KPI’s will result in the sales team consciously looking for ways to make those incremental improvements that when tallied up over a financial year, can make a significant difference to revenue attainment. As the old saying goes, in order to manage something, you first must be able to measure it, and my experience tells me that bringing these 2 key measurements (levers) into focus will always pay short, medium and long term dividends.</p><p>Discover more important lessons regarding the modern approach to sales in my new book – ‘Sales Transformation’.</p></div>


        </div>
            
        <aside className="article__sidebar col-sm-12 col-md-4 col-lg-offset-1 col-lg-3">
            <div className="article__sidebar-wrap" id="article-sidebar">
                <div className="card card--profile">
                        
<div className="card__header">
    <div className="card__image">
        <img alt="Mentor Thumb Graham Hawkins" className="img-responsive" height="165" src="../../../media/images/Mentor-Thumb-Graham-Hawkins.2e16d0ba.fill-165x165.jpg" width="165"/>
    </div>
    <div className="card__title">
        <h4>Graham Hawkins</h4>
        <p>SalesTribe Mentor</p>
        <Link to="solutions/find-a-mentor/graham-hawkins" className="btn btn-link hidden-md hidden-lg">View full profile</Link>
    </div>
</div>
<div className="rich-text"><p>With more than twenty-eight years of business experience in
executive B2B sales and sales leadership roles, Graham is a highly experienced
and versatile business executive with proven strengths in strategic business
development, go-to-market planning and sales and marketing.</p><p><br/></p><p><br/></p></div>
<Link to="solutions/find-a-mentor/graham-hawkins" className="btn btn-link hidden-xs hidden-sm">View full profile</Link>

                </div>
                <nav className="social-nav">
    <h4>Share</h4>
    <ul>
        <li className="linkedin">
            <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https%3A//salestribe.com/knowledge-centre/insights/sales-uplift-two-simple-ways-create-sales-performance-improvement/&amp;title=Sales%20uplift%20-%202%20simple%20ways%20to%20create%20performance%20improvement.&amp;summary=Sales%20uplift%20-%202%20simple%20ways%20to%20create%20performance%20improvement.&amp;source=https%3A//salestribe.com/knowledge-centre/insights/sales-uplift-two-simple-ways-create-sales-performance-improvement/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">LinkedIn</span>
                <span className="icon icon-linkedin"></span>
                
            </a>
        </li>
        <li className="twitter">
            <a href="https://twitter.com/intent/tweet/?text=Sales%20uplift%20-%202%20simple%20ways%20to%20create%20performance%20improvement.&amp;url=https%3A//salestribe.com/knowledge-centre/insights/sales-uplift-two-simple-ways-create-sales-performance-improvement/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Twitter</span>
                <span className="icon icon-twitter"></span>
                
            </a>
        </li>
        <li className="googleplus">
            <a href="https://plus.google.com/share?url=https%3A//salestribe.com/knowledge-centre/insights/sales-uplift-two-simple-ways-create-sales-performance-improvement/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Google+</span>
                <span className="icon icon-google-plus"></span>
                
            </a>
        </li>
        <li className="facebook">
            <a href="https://facebook.com/sharer/sharer.php?u=https%3A//salestribe.com/knowledge-centre/insights/sales-uplift-two-simple-ways-create-sales-performance-improvement/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Facebook</span>
                <span className="icon icon-facebook-f"></span>
                
            </a>
        </li>
        <li className="email">
            <Link to="knowledge-centre/insights/mailto:?subject=Sales%20uplift%20-%202%20simple%20ways%20to%20create%20performance%20improvement.&amp;body=https%3A//salestribe.com/knowledge-centre/insights/sales-uplift-two-simple-ways-create-sales-performance-improvement/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Email</span>
                <span className="icon icon-envelope"></span>
                
            </Link>
        </li>
    </ul>
</nav>

            </div>
        </aside>
            
    </div>
</div>
</article>

<div className="block block--grey related-items">
    <div className="related-items__wrap">
        <div className="container">
            <div className="row" data-tablet-slick>
                
        <article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/sales-training-complete-waste-money-and-time-part-2" className="card card--article">
                <div className="card__thumb">
                    <img alt="article-connect-coffee-chat.jpg" className="card__image" height="404" src="../../../media/images/article-connect-coffee-chat_xr8wJT.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">5 min read</span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>Sales Training’ is a waste of money and time (Part 2)</strong></h3>
                    </header>
                    <p>We must stop teaching sales people how to ‘push’ buyers, and instead start training and coaching them on how to become highly specialised teachers.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article><article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/sales-training-waste-time-and-money-part-1" className="card card--article">
                <div className="card__thumb">
                    <img alt="article-connect-coffee-chat.jpg" className="card__image" height="404" src="../../../media/images/article-connect-coffee-chat_xr8wJT.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">4 min read</span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>‘Sales Training’ is a waste of time and money (Part 1)</strong></h3>
                    </header>
                    <p>When you teach sales people how to ‘push’ buyers through a sales playbook you are teaching them how to destroy your business reputation.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article><article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/b2b-sales-has-changed-about-180-degrees" className="card card--article">
                <div className="card__thumb">
                    <img alt="Mentor Large Graham Hawkins" className="card__image" height="404" src="../../../media/images/Mentor-Large-Graham-Hawkins.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">04:28</span>
                    <span className="card__icon play-icon">
                        <i className="icon"></i>
                    </span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>B2B Sales has changed about 180 Degrees!</strong></h3>
                    </header>
                    <p>B2B sales has now changed so dramatically that it&#39;s a &quot;profession&quot; that is barely recognisable to the role that both Tony Hughes and Graham Hawkins began about 30 years ago - respectively.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article>

            </div>
            <div className="load-more">
                <Link to="knowledge-centre/insights/" className="btn btn-link">Browse more insights</Link>
            </div>
        </div>
    </div>
</div>


      
      <FooterAlternate1 />

    </Layout>
)

export default IndexPage 